const getSelectedAttachables = (context, object) => {
  context.commit("ATTACHABLE_CATEGORY_SELECTED_ATTACHABLES_UPDATED", object.selectedAttachables);
};

const resetSelectedAttachables = (context) => {
  context.commit("RESET_ATTACHABLE_CATEGORY_SELECTED_ATTACHABLES_UPDATED");
};

export default {
  getSelectedAttachables,
  resetSelectedAttachables,
};
